// Libraries
import { useTranslation } from "react-i18next";

// Material UI
import { InputAdornment } from "@mui/material";
import { LockOutlined } from "@mui/icons-material";

// Components
import PasswordField from "Components/PasswordField";

// Common
import { FormikTextField } from "Common/Components";

const MBSPasswordFields = ({ formik, newPasswordHelperError }) => {
  const { t } = useTranslation();

  return (
    <>
      <PasswordField
        formik={formik}
        name="newPassword"
        label={t("mbsAuth.newPassword")}
        autoComplete="new-password"
        extraHelperError={newPasswordHelperError}
      />
      <FormikTextField
        formik={formik}
        name="confirmNewPassword"
        field={{
          type: "password",
          label: t("mbsAuth.confirmNewPassword"),
          required: false,
          autoComplete: "new-password",
          slotProps: {
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <LockOutlined />
                </InputAdornment>
              ),
            },
          },
        }}
      />
    </>
  );
};

export default MBSPasswordFields;
